<form [formGroup]="servicesForm" class="form was-validated">
  <ix-typography format="h3">Services</ix-typography>
  <div class="container">
    <div class="column">
      <ix-typography format="h4">Available</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-ContinuousMonitoring" aria-describedby="tooltip-ContinuousMonitoring"
              >Continuous Monitoring</label
            >
            <ix-tooltip id="tooltip-ContinuousMonitoring" for=".tooltip-ContinuousMonitoring">{{
              servicesForm.controls[fields.CONTINUOUS_MONITORING_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-col>
              <ix-input type="text" value="included" readonly></ix-input>
            </ix-col>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-IncidentManagement" aria-describedby="tooltip-IncidentManagement"
              >Incident Management</label
            >
            <ix-tooltip id="tooltip-IncidentManagement" for=".tooltip-IncidentManagement">{{
              servicesForm.controls[fields.INCIDENT_MANAGEMENT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.INCIDENT_MANAGEMENT">
              @for (option of dropdowns[fields.INCIDENT_MANAGEMENT]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-NetworkManagement" aria-describedby="tooltip-NetworkManagement"
              >Network Management</label
            >
            <ix-tooltip id="tooltip-NetworkManagement" for=".tooltip-NetworkManagement">{{
              servicesForm.controls[fields.NETWORK_MANAGEMENT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.NETWORK_MANAGEMENT">
              @for (option of dropdowns[fields.NETWORK_MANAGEMENT]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-DomainManagement" aria-describedby="tooltip-DomainManagement"
              >Domain Management</label
            >
            <ix-tooltip id="tooltip-DomainManagement" for=".tooltip-DomainManagement">{{
              servicesForm.controls[fields.DOMAIN_MANAGEMENT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.DOMAIN_MANAGEMENT">
              @for (option of dropdowns[fields.DOMAIN_MANAGEMENT]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>

    <div class="column">
      <ix-typography format="h4">Maintained</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label
              class="tooltip-PreventivePeriodicMaintenance"
              aria-describedby="tooltip-PreventivePeriodicMaintenance"
              >Preventive & Periodic Maintenance</label
            >
            <ix-tooltip id="tooltip-PreventivePeriodicMaintenance" for=".tooltip-PreventivePeriodicMaintenance">{{
              servicesForm.controls[fields.PREVENTIVE_PERIODIC_MAINTENANCE_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select
              class="ix-select"
              name="ix-select-control"
              [formControlName]="fields.PREVENTIVE_PERIODIC_MAINTENANCE"
            >
              @for (option of dropdowns[fields.PREVENTIVE_PERIODIC_MAINTENANCE]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        @if (servicesForm.controls[fields.PREVENTIVE_PERIODIC_MAINTENANCE].value === 'Yes') {
          <ix-row>
            <ix-col size="7" size-sm="12">
              <label
                class="tooltip-PreventiveSchedulefrequencyPP"
                aria-describedby="tooltip-PreventiveSchedulefrequencyPP"
                >Preventive & Periodic Maintenance - Schedule frequency</label
              >
              <ix-tooltip id="tooltip-PreventiveSchedulefrequencyPP" for=".tooltip-PreventiveSchedulefrequencyPP">{{
                servicesForm.controls[fields.SCHEDULE_FREQUENCY_PP_TOOLTIP].value
              }}</ix-tooltip>
            </ix-col>
            <ix-col>
              <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SCHEDULE_FREQUENCY_PP">
                @for (option of dropdowns[fields.SCHEDULE_FREQUENCY_PP]; track option) {
                  <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
                }
              </ix-select>
            </ix-col>
          </ix-row>
        }
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-Updatespacthes" aria-describedby="tooltip-Updatespacthes">Updates & Patches</label>
            <ix-tooltip id="tooltip-Updatespacthes" for=".tooltip-Updatespacthes">{{
              servicesForm.controls[fields.UPDATES_PATCHES_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.UPDATES_PATCHES">
              @for (option of dropdowns[fields.UPDATES_PATCHES]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        @if (servicesForm.controls[fields.UPDATES_PATCHES].value === 'Yes') {
          <ix-row>
            <ix-col size="7" size-sm="12">
              <label class="tooltip-SchedulefrequencyUP" aria-describedby="tooltip-SchedulefrequencyUP"
                >Updates & Patches - Schedule frequency</label
              >
              <ix-tooltip id="tooltip-SchedulefrequencyUP" for=".tooltip-SchedulefrequencyUP">{{
                servicesForm.controls[fields.SCHEDULE_FREQUENCY_UP_TOOLTIP].value
              }}</ix-tooltip>
            </ix-col>
            <ix-col>
              <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SCHEDULE_FREQUENCY_UP">
                @for (option of dropdowns[fields.SCHEDULE_FREQUENCY_UP]; track option) {
                  <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
                }
              </ix-select>
            </ix-col>
          </ix-row>
        }
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-Back-upRestore" aria-describedby="tooltip-Back-upRestore">Back-up & Restore</label>
            <ix-tooltip id="tooltip-Back-upRestore" for=".tooltip-Back-upRestore">{{
              servicesForm.controls[fields.BACKUP_RESTORE_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.BACKUP_RESTORE">
              @for (option of dropdowns[fields.BACKUP_RESTORE]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>
  </div>

  <div class="container">
    <div class="column">
      <ix-typography format="h4">Secured</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-VulnerabilityManagement" aria-describedby="tooltip-VulnerabilityManagement"
              >Vulnerability Management</label
            >
            <ix-tooltip id="tooltip-VulnerabilityManagement" for=".tooltip-VulnerabilityManagement">{{
              servicesForm.controls[fields.VULNERABILITY_MANAGEMENT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.VULNERABILITY_MANAGEMENT">
              @for (option of dropdowns[fields.VULNERABILITY_MANAGEMENT]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-AnomalyDetection" aria-describedby="tooltip-AnomalyDetection"
              >Anomaly Detection</label
            >
            <ix-tooltip id="tooltip-AnomalyDetection" for=".tooltip-AnomalyDetection">{{
              servicesForm.controls[fields.ANOMALY_DETECTION_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.ANOMALY_DETECTION">
              @for (option of dropdowns[fields.ANOMALY_DETECTION]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-SOCaaS" aria-describedby="tooltip-SOCaaS">SOCaaS (24/7)</label>
            <ix-tooltip id="tooltip-SOCaaS" for=".tooltip-SOCaaS">{{
              servicesForm.controls[fields.SOCAAS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SOCAAS">
              @for (option of dropdowns[fields.SOCAAS]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>
    <div class="column">
      <ix-typography format="h4">Supported</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-RemoteSupport" aria-describedby="tooltip-RemoteSupport">Remote Support</label>
            <ix-tooltip id="tooltip-RemoteSupport" for=".tooltip-RemoteSupport">{{
              servicesForm.controls[fields.REMOTE_SUPPORT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.REMOTE_SUPPORT">
              @for (option of dropdowns[fields.REMOTE_SUPPORT]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-ServiceDesk" aria-describedby="tooltip-ServiceDesk">Service Desk</label>
            <ix-tooltip id="tooltip-ServiceDesk" for=".tooltip-ServiceDesk">{{
              servicesForm.controls[fields.SERVICE_DESK_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SERVICE_DESK">
              @for (option of dropdowns[fields.SERVICE_DESK]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-ServiceRequest" aria-describedby="tooltip-ServiceRequest">Service Request</label>
            <ix-tooltip id="tooltip-ServiceRequest" for=".tooltip-ServiceRequest">{{
              servicesForm.controls[fields.SERVICE_REQUEST_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SERVICE_REQUEST">
              @for (option of dropdowns[fields.SERVICE_REQUEST]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        @if (servicesForm.controls[fields.SERVICE_REQUEST].value === 'Yes') {
          <ix-row>
            <ix-col size="7" size-sm="12">
              <label class="tooltip-ServiceRequesthours" aria-describedby="tooltip-ServiceRequesthours"
                >Service Request (hours)</label
              >
              <ix-tooltip id="tooltip-ServiceRequesthours" for=".tooltip-ServiceRequesthours">{{
                servicesForm.controls[fields.SERVICE_REQUEST_HOURS_TOOLTIP].value
              }}</ix-tooltip>
            </ix-col>
            <ix-col>
              <ix-number-input
                [formControlName]="fields.SERVICE_REQUEST_HOURS"
                pattern="[0-9]+"
                min="0"
                [invalidText]="validationFeedback.negativeInteger"
              >
                <ix-typography slot="end">hours covered</ix-typography>
              </ix-number-input>
            </ix-col>
          </ix-row>
        }
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label>Technical Product & Hardware Support</label>
          </ix-col>
          <ix-col>
            <ix-input type="text" value="included" readonly></ix-input>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>
  </div>
  <div class="container">
    <div class="column">
      <ix-typography format="h4">Onboarding Services</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-cRSP" aria-describedby="tooltip-cRSP">cRSP setup needed?</label>
            <ix-tooltip id="tooltip-cRSP" for=".tooltip-cRSP">{{
              servicesForm.controls[fields.CRSP_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.CRSP">
              @for (option of dropdowns[fields.CRSP]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-onboardingcustomer" aria-describedby="tooltip-onboardingcustomer"
              >Onboarding Customer</label
            >
            <ix-tooltip id="tooltip-onboardingcustomer" for=".tooltip-onboardingcustomer">{{
              servicesForm.controls[fields.ONBOARDING_CUSTOMER_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.ONBOARDING_CUSTOMER">
              @for (option of dropdowns[fields.ONBOARDING_CUSTOMER]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
        @if (servicesForm.controls[fields.ONBOARDING_ANOMALY_VISIBLE].value === 'Yes') {
          <ix-row>
            <ix-col size="7" size-sm="12">
              <label class="tooltip-onboardinganomaly" aria-describedby="tooltip-onboardinganomaly"
                >Onboarding Anomaly</label
              >
              <ix-tooltip id="tooltip-onboardinganomaly" for=".tooltip-onboardinganomaly">{{
                servicesForm.controls[fields.ONBOARDING_ANOMALY_TOOLTIP].value
              }}</ix-tooltip>
            </ix-col>
            <ix-col>
              <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.ONBOARDING_ANOMALY">
                @for (option of dropdowns[fields.ONBOARDING_ANOMALY]; track option) {
                  <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
                }
              </ix-select>
            </ix-col>
          </ix-row>
        }
        <ix-row>
          <ix-col size="7" size-sm="12">
            <label class="tooltip-onboardingSOCaaS" aria-describedby="tooltip-onboardingSOCaaS"
              >Onboarding SOCaaS</label
            >
            <ix-tooltip id="tooltip-onboardingSOCaaS" for=".tooltip-onboardingSOCaaS">{{
              servicesForm.controls[fields.ONBOARDING_SOCAAS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.ONBOARDING_SOCAAS">
              @for (option of dropdowns[fields.ONBOARDING_SOCAAS]; track option) {
                <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
              }
            </ix-select>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>
    <div class="column"></div>
  </div>

  <div class="button-container">
    <ix-button variant="subtle-primary" class="m-1 back-button" (click)="stepBack()">Back</ix-button>
    <ix-button variant="primary" class="next-button" (click)="nextStep()">Next</ix-button>
  </div>
</form>
